/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import Clipboard from 'clipboard';
import { injectIntl } from 'react-intl';
import {
  Tooltip,
  OverlayTrigger,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import Flash from '../Flash';

const defaultProps = {
  text: '',
};

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  id: React.PropTypes.string.isRequired,
  text: React.PropTypes.string,
};

class Copy extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      text: props.text,
    };
    this.intlMsg = new IntlMsg(props.intl, 'lora.coms.copy');

    const copy = new Clipboard(`#${props.id}`);
    const that = this;
    copy.on('success', () => {
      that.setState({ copied: true });
    });
  }

  componentWillReceiveProps(nextProps) {
    const { text } = nextProps;
    this.setState({ text });
  }

  render() {
    const { id } = this.props;
    const { text, copied = false } = this.state;
    const tooltip = <Tooltip id={`tooltip-${id}`}>{this.intlMsg.msg('copy')}</Tooltip>;
    return (
      <span>
        <OverlayTrigger
          placement="top"
          overlay={tooltip}
          delayShow={500}
        >
          <a id={id} data-clipboard-text={text}>
            <span className="halflings halflings-copy" />
          </a>
        </OverlayTrigger>
        <Flash
          show={copied}
          message={this.intlMsg.msg('copied')}
          onHide={() => this.setState({ copied: false })}
          azStyle="success"
        />
      </span>
    );
  }
}

Copy.defaultProps = defaultProps;
Copy.propTypes = propTypes;

export default injectIntl(Copy);




// WEBPACK FOOTER //
// ./src/components/Copy/index.jsx